<app-section-header surtitle="La carte" title="La Carte"></app-section-header>

<div class="menu-container">
    <ng-container *ngFor="let type of menuTypes">
        <div class="menu-section">
            <div class="section-header">
                <h3 class="section-name">{{ type }}</h3>
                <div class="section-line"></div>
            </div>
            <div class="menu-items-list">
                <div class="menu-item" *ngFor="let item of filteredMenu(type); let i = index"
                    appScrollReveal [revealDelay]="(i % 8) * 50">
                    <div class="item-header">
                        <span class="item-name">{{ item.name }}</span>
                        <span class="item-dots"></span>
                        <span class="price">{{ item.price | currency:'EUR':'symbol':'1.0-2' }}</span>
                    </div>
                    <p class="item-desc" *ngIf="item.description">{{ item.description }}</p>
                </div>
            </div>
        </div>
    </ng-container>
</div>
